import styled from 'styled-components';

export const Wrapper = styled.div`
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.black4};
  background: ${({ theme }) => theme.colors.white};
  display: flex;
  width: 100%;
  padding: 20px;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  align-self: stretch;
  width: 100%;
  min-height: 0;
`;

export const IndexAnswer = styled.span`
  color: ${({ theme }) => theme.colors.black9};
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.2px;
`;

export const QuestionTitle = styled.span`
  color: ${({ theme }) => theme.colors.black9};
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`;

export const TitleWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;

export const FormulaWrapper = styled.div`
  display: flex;
`;

export const StyledImage = styled.img`
  width: fit-content;
  max-width: 100%;
  height: auto;
`;

export const AnswersWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;

  .ant-radio-group {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .ant-radio-wrapper {
    width: 100%;
    min-height: 48px;
    padding: 12px 0px 12px 16px;
    align-items: center;
    gap: 16px;
    border-radius: 4px;
    border: 1px solid ${({ theme }) => theme.colors.black4};
    background: ${({ theme }) => theme.colors.white};

    &.selected {
      border: 1px solid ${({ theme }) => theme.colors.black9};
      background: ${({ theme }) => theme.colors.white};
    }

    &.correct {
      border: 1px solid ${({ theme }) => theme.colors.green6};
      background: ${({ theme }) => theme.colors.green1};
    }

    &.incorrect {
      border: 1px solid ${({ theme }) => theme.colors.red6};
      background: ${({ theme }) => theme.colors.red1};
    }

    &:hover:not(.selected, .correct, .incorrect) {
      border: 1px solid ${({ theme }) => theme.colors.black4};
      background: ${({ theme }) => theme.colors.black1};
    }

    &:active {
      border: 1px solid ${({ theme }) => theme.colors.black9};
      background: ${({ theme }) => theme.colors.white};
    }

    & > span.ant-radio + * {
      width: 100%;
      padding-inline-end: 0 !important;
    }
  }
`;

export const FooterWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  width: 100%;
`;

export const SectionWrapper = styled.div`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  flex: 1 0 0;
  overflow: hidden;
  color: ${({ theme }) => theme.colors.black7};
  text-overflow: ellipsis;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
`;
